import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { IconList } from '../UiKit/IconList';
import { TooltipH } from '../UiKit/TooltipH';
import { PentaContainer } from './PentaContainer';
import { PentasChoose } from './PentasChoose';
import { Button } from '../UiKit/Button';
import { Appearer } from '../UiKit/Appearer';


export function Pentas({
  icon = 'diversity_3',
  max = 2,
  min = 0,
  title = '',
  create,
  mode = 'hd',
}) {


  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const [expanded, setExpanded] = useState(false);

  const setExpandedSafe = (val) => {
    if (!val) {
      setExpanded(false);
      if (context.state.pentaChooseId === expanded) {
        context.setState.setPentaChooseId(false);
      }
      return;
    }
    setExpanded(val);
    context.setState.setPentaChooseId(val);
  };

  useEffect(() => {
    const chosenId = context.state.pentaChooseId;
    if (!chosenId) return;

    const penta = context.pentas.find(one => one.token === chosenId);
    const belongsHere = penta
      && penta.members.length > min - 1
      && penta.members.length < max + 1;

    if (belongsHere) {
      setExpanded(chosenId);
    }
  }, [context.state.pentaChooseId])

  useEffect(() => {
    if (!context.state.peoplePanel) {
      setExpanded(false);
      if (context.state.pentaChooseId) {
        context.setState.setPentaChooseId(false);
      }
    }
  }, [context.state.peoplePanel])


  const handleChoose = (val) => {
    if (!context.state.peoplePanel) context.setState.showPeoplePanel(['pentas']);
    setExpandedSafe(val);
  }

  const [active, setActive] = useState()
  const { pentaId } = useParams();


  const count = context.pentas.filter(one => (one.members.length > min - 1 && one.members.length < max + 1)).length

  return (
    <>




      <PentasChoose
        pentaId={expanded}
        setExpanded={setExpandedSafe}
        expanded={expanded}
      />

      <div
        name={`pentas`}
        className={context.state.peoplePanel ? "x_choose_section x_choose_section--v" : "x_choose_section"}
      >

        <PentasTitle icon={icon} title={title} count={count} create={create} />

        <div className={context.state.peoplePanel ? `x_choose x_choose_pentas x_choose_pentas--v ${context.state.pentaFolders ? ' x_choose_pentas--groups' : ''}` : "x_choose x_choose_pentas"}>

          {(() => {
            // console.time('pentas-render');
            const filteredPentas = context.pentas
              .filter(one => one.members.length > min - 1 && one.members.length < max + 1);

            const renderedPentas = filteredPentas.map((one, ind) =>
              <Appearer key={`penta_${one.token}`} order={ind}>
                <PentaContainer
                  setExpanded={setExpandedSafe}
                  peoplePanel={context.state.peoplePanel}
                  handleChoose={handleChoose}
                  quantity={context.pentas.length}
                  listId={one.token}
                  penta={one}
                  mode={mode}
                />
              </Appearer>
            );

            // console.timeEnd('pentas-render');
            return renderedPentas;
          })()}

          {create && context.state.peoplePanel && <div className={context.state.peoplePanel ? "x_penta0 x_penta0--v" : "x_penta0"}>
            <div
              onClick={() => context.x.createPentaWithMe()}
              className="x_penta_table x_penta_table--add"><div className="x_choose_one_action"><div className="t_icon t_icon--100"><div>add</div></div><div>
                {$ui('penta_new')}
              </div></div></div>
          </div>}

        </div>
      </div>




    </>
  )
}



export const PentasTitle = ({ icon, title, count, create }) => {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  return (
    <div className={context.state.peoplePanel ? "x_choose_section_title0 x_choose_section_title0--v" : "x_choose_section_title0"}>
      <div className={context.state.peoplePanel ? "x_choose_section_header x_choose_section_header--v" : "x_choose_section_header"}>
        <div className={context.state.peoplePanel ? "x_choose_section_title x_choose_section_title--v" : "x_choose_section_title"}>

          <IconList icon={icon} q={count} /> {title}

          {Boolean(context.pentas.length) && <div className="x_choose_menu_counter">
            {count}
          </div>}

        </div>

        <div className="x_choose_section_header_left ">
          {create && <div className="x_choose_section_header_left_inner _fgap14">
            <Button 
              sm 
              icon='add' 
              onClick={() => context.x.createPentaWithMe()}
              tooltipMobileOff
              labelMobileOff
            >
              {$ui('button_create_new')}
            </Button>
          </div>}
        </div>
        <div className="x_choose_section_header_right mobile_v_no">
        </div>

        {context.state.peoplePanel && <div className="x_choose_section_header_right _fgap1">


          <TooltipH title={$ui('people_private_tooltip')} placement='bottom'>
            <div className="x_choose_menu_label"><div className="t_icon">lock</div>
              {/* <div className="mobile_v_no">
              {$ui('people_private_list')}
            </div> */}
            </div>
          </TooltipH>
        </div>}

      </div>
    </div>
  )
}